<template>
    <VehicleDetail Project="QM"/>
</template>

<script>
import VehicleDetail from '../PRODUCTION/Macchine/VehicleDetail.vue'

export default {
    components:{
      VehicleDetail
    }
}
</script>